module.exports = __webpack_public_path__ + "static/media/404.19be9e63.png";